import { useState, useEffect, useLayoutEffect, CSSProperties, useRef } from "react";
import { getOrgAlarmTypes, getProjectAlarmTypes } from "../../../api/dashboard";
import ChartCanvas from './ChartCanvas'
import { EChartsInitOpts } from "echarts";
import { Title, Loading } from "../Layouts";

export default function AlarmTypesPie(p: { round?: boolean, hideLegend?: boolean,  orgId?: any, projectId?: any, style: CSSProperties }) {
    const [options, setOptions] = useState<EChartsInitOpts>();
    const titleRef = useRef<HTMLDivElement>(null);
    const [canvasHeight, setCanvasHeight] = useState((p.style.height as number) - 27.5);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (!p.projectId && !p.orgId) return;
        setLoading(true);
        (
            p.orgId ? getOrgAlarmTypes(p.orgId) :
            getProjectAlarmTypes(p.projectId)
        )
            .then((_res) => {
                const res = {
                    ..._res,
                    alarmStatistics: [
                        ..._res.alarmStatistics,
                    ]
                }
                const option = {
                    backgroundColor: 'rgb(9, 53, 99)',
                    tooltip: {
                        trigger: 'item'
                    },
                    legend: {
                        show: p.hideLegend ? false : true,
                        formatter: (name: string) => {
                            return `${name}(${res.alarmStatistics.find(i => i.type === name)?.cnt})`
                        }
                    },
                    series: [
                        {
                            ...(
                                p.round ? {} : {
                                    startAngle: 360,
                                    endAngle: 180,
                                }
                            ),
                            type: 'pie',
                            radius: [20, 40],
                            center: ['50%', '50%'],
                            itemStyle: {
                                borderRadius: 0
                            },
                            data: res.alarmStatistics.map(i => {
                                return {
                                    value: i.cnt, name: `${i.type}`
                                }
                            })
                        }
                    ]
                };
                setOptions(option as any)
            })
            .finally(() => {
                setLoading(false)
            })
    }, [p.orgId, p.projectId, p.hideLegend, p.round]);
    useLayoutEffect(() => {
        if (titleRef.current) {
            setCanvasHeight((p.style.height as number) - titleRef.current.clientHeight)
        }
    }, [p.style.height])
    return <div style={{ ...p.style }}>
        <Title ref={titleRef}>告警类型汇总</Title>
        {
            loading ?
                <div style={{
                    width: p.style.width, height: canvasHeight,
                    background: 'rgb(9, 53, 99)'
                }}>
                    <Loading />
                </div> :
                <ChartCanvas options={options} styles={{
                    width: p.style.width, height: canvasHeight,
                }} />
        }
    </div>
}